export default "__VITE_ASSET__6b7ccfe6__"